import { Autocomplete, TextField } from '@mui/material'
import Paper from "@material-ui/core/Paper";
import { PaperProps } from '@material-ui/core/Paper';
import { useEffect, useState } from 'react';
import { countries } from '../../Utils/common';
import './style.scss'

// Type for individual country object from the countries array
interface Country {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
}

// Type for the transformed country option used in the autocomplete
interface CountryOption {
    label: string;
    value: string;
}

const CustomPaper = (props: PaperProps) => {
    return (
        <Paper
            style={{ color: "#FFFF", background: "transparent", marginBottom: '10px', borderBottom: '2px dashed #FFFF' }}
            {...props}
        />
    );
};

interface CountryInputProps {
    fromInput?: boolean;
}

const CountryInput = ({ fromInput }: CountryInputProps) => {

    const [countryArray, setCountryArray] = useState<CountryOption[]>([])

    useEffect(() => {
        const countryArr: CountryOption[] = []
        countries.forEach((country: Country) => {
            countryArr.push({
                label: country?.name,
                value: country?.code
            })
        })
        setCountryArray(countryArr)
    }, [])

    return (
        <Autocomplete
            classes={{
                paper: "country-autocomplete"
            }}
            options={countryArray}
            getOptionLabel={(option) => option?.label || ""}
            renderInput={(params) => (
                <TextField {...params} placeholder="Type or select an option" variant="standard" />
            )}
            isOptionEqualToValue={(option, value) => {
                return option.label === value.label;
            }}
            PaperComponent={CustomPaper}
            onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
            className={fromInput ? "country-autocomplete country-input-small" : "country-autocomplete"}
        />
    )
}

export default CountryInput